import React from 'react';

import RecentlyPlayedMenu from '../../../left-bar/RecentlyPlayedMenu';
import CollectionMenu from '../../../left-bar/CollectionMenu';
import NewPlaylistMenu from '../../../left-bar/NewPlaylistMenu';
import CartMenu from '../../../cart/CartMenu';

function MyPlaylistsMenuSection() {
  return (
    <div className={`flexColumn`} style={{margin: 8}}>
      <CollectionMenu />
      <CartMenu />
      <RecentlyPlayedMenu />
      <NewPlaylistMenu />
    </div>
  )
}

export default MyPlaylistsMenuSection;
